module.exports = __webpack_public_path__ + "img/writing.35f16430.jpeg";